export default __webpack_public_path__ + "static/media/WorkSans-VariableFont_wght.bb6e3e81.ttf";